import { Alert, AlertColor, Typography } from "@mui/material";

type Props = {
  can_delivery_to_selected_address: number | undefined
}

type DisplayData = {
  severity: AlertColor, message: string
}

export default function DeliveryDistanceWarning({ can_delivery_to_selected_address }: Props) {

  // se for undefined, provavelmente não temos shopping bag
  // de qualquer forma, não mostramos nada
  if (can_delivery_to_selected_address === undefined) return (<></>);

  // se for 0 significa yes, não precisa do aviso.
  if (can_delivery_to_selected_address === 0) return (<></>);

  // se for outro valor, temos algum problema:

  let dados: DisplayData;

  // se for 1, significa que temos certeza que está fora da área de entrega
  if (can_delivery_to_selected_address === 1) {
    dados = { severity: "error", message: "Desculpe, o endereço selecionado está fora da área de entrega." };
  }
    // se for 3, significa que usuário ainda não cadastrou o endereço.
    // isto em tese não vai ocorrer, pq quando user entra no cardápio, é criado login
    // visitante e o backend utiliza o mesmo endereço do restaurante para esse login.
  // mas talvez isso mude um dia, e aí já vai estar preparado:
  else if (can_delivery_to_selected_address === 3) {
    dados = {
      severity: "warning",
      message: "Aviso: não encontramos um endereço de entrega cadastrado. Por favor, cadastre um endereço "
        + "para poder confirmar que está dentro da área de entrega.",
    };
  }

  // se for qualquer outro caso, não temos certeza se dá pra entregar ou não:
  else {
    dados = {
      severity: "info",
      message: "Desculpe, não conseguimos confirmar que o endereço selecionado está dentro da área de entrega. "
        + "Você pode entrar em contato e verificar ou, se preferir, fazer o pedido e aguardar o Restaurante aceitar ou rejeitar, caso"
        + " esteja fora da área de entrega.",
    };
  }

  return (<Alert
      severity={dados.severity}
      sx={{
        display: "flex", flexGrow: 1, alignItems: "center", justifyContent: "center",
      }}
    >
      <Typography fontSize="11px" fontWeight={700}>
        {dados.message}
      </Typography>
    </Alert>


  );
}